import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import { toast } from "react-toastify";

const PostsByCategory = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catRes, postsRes] = await Promise.all([
          axios.get("/api_w/postcategories", {
            headers: { db_name: process.env.REACT_APP_DB_NAME },
          }),
          axios.get("/api_w/posts", {
            headers: { db_name: process.env.REACT_APP_DB_NAME },
          }),
        ]);

        const cats = catRes.data.data || [];
        const posts = postsRes.data.data || [];

        // Count posts per category
        const counted = cats.map((cat) => ({
          name: cat.name,
          count: posts.filter((p) => p.category_id === cat.id).length,
        }));

        // Sort by count descending
        counted.sort((a, b) => b.count - a.count);
        setCategories(counted);
      } catch (error) {
        toast.error("Gagal memuat data kategori");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const chartOptions = {
    chart: {
      type: "bar",
      fontFamily: "Onest, sans-serif",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        horizontal: true,
        barHeight: "60%",
        distributed: false,
      },
    },
    colors: ["#16a34a"],
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        colors: ["#fff"],
      },
    },
    xaxis: {
      categories: categories.map((c) => c.name),
      labels: {
        style: { colors: "#a3aed0", fontSize: "12px" },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: { colors: "#a3aed0", fontSize: "12px" },
      },
    },
    grid: {
      show: false,
      borderColor: "#e9ecef",
    },
    tooltip: {
      theme: "dark",
      y: { formatter: (val) => `${val} postingan` },
    },
  };

  const chartSeries = [
    {
      name: "Jumlah Postingan",
      data: categories.map((c) => c.count),
    },
  ];

  return (
    <div className="flex flex-col rounded-[20px] bg-white px-6 pb-4 pt-6 shadow-xl shadow-shadow-500 dark:bg-navy-800 dark:shadow-none">
      <h4 className="mb-4 text-lg font-bold text-navy-700 dark:text-white">
        Postingan per Kategori
      </h4>
      {loading ? (
        <div className="flex items-center justify-center py-8">
          <div className="h-6 w-6 animate-spin rounded-full border-2 border-brand-500 border-t-transparent" />
        </div>
      ) : categories.length === 0 ? (
        <div className="flex items-center justify-center py-8 text-gray-400">
          <p className="text-sm">Belum ada data kategori</p>
        </div>
      ) : (
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="bar"
          height={categories.length * 45 + 50}
        />
      )}
    </div>
  );
};

export default PostsByCategory;
